import mapKeys from 'lodash/mapKeys';
import snakeCase from 'lodash/snakeCase';

import {spotheroPost} from 'api';
import dayjs from 'utils/dayjs';
import {camelizeKeys} from 'utils/format-strings';
import {sendSentryException} from 'utils/error-handling';

import {
    GetEventListRequest,
    RawGetEventListRequest,
    GetEventListResponse,
    EventListItem,
} from './events.types';
import {apiDateFormat} from 'hooks/config';

/**
 * Formats the events list response.
 */
const formatEventRatesResponse = (data: GetEventListResponse) => {
    const formatedData = camelizeKeys(data);

    return formatedData;
};

/**
 * Formats the request to get events list.
 */
const formatEventRatesRequest = (
    data: GetEventListRequest
): RawGetEventListRequest => {
    const formatedData = mapKeys(data, (value, key) => snakeCase(key));

    return {
        ...formatedData,
        // eslint-disable-next-line camelcase
        from_date: data.fromDate && dayjs(data.fromDate).format(apiDateFormat),
        // eslint-disable-next-line camelcase
        to_date: data.toDate && dayjs(data.toDate).format(apiDateFormat),
    };
};

/**
 * Gets a list of events for a given facility and date range.
 * @see https://spothero.com/api/v1/docs/endpoints/?new-docs=true#!/Events/get_facilities_facility_id_event_attribution_list
 */
const getEventsList = async (
    facilityId: number,
    requestData: GetEventListRequest,
    config = {}
) => {
    try {
        const formattedRequest = formatEventRatesRequest(requestData);

        const response = await spotheroPost<EventListItem[]>(
            `facilities/${facilityId}/event-attribution-list/`,
            formattedRequest,
            config,
            false
        );
        const formatedResponse = formatEventRatesResponse(response.data);

        return formatedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default getEventsList;
